import React from 'react';
import highlightStyles from '../components/HighlightText/styles';

const createHighlightedParts = (
  text: string,
  searchQuery?: string
): React.ReactNode => {
  if (!searchQuery || !text) {
    return text;
  }

  const regex = new RegExp(
    `(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
    'gi'
  );
  const parts = text.split(regex);

  return parts.map((part, index) => {
    const isMatch = regex.test(part);
    regex.lastIndex = 0;

    return isMatch ? (
      <span key={index} style={highlightStyles}>
        {part}
      </span>
    ) : (
      part
    );
  });
};

export default createHighlightedParts;
